export const capitalizeFirstLetterString = ([firstLetter, ...rest]: string): string => {
  return [firstLetter.toUpperCase(), ...rest.join('').toLowerCase()].join('');
};
